// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useTranslation } from 'react-i18next';
import { KpiData } from './useContractKpiApi';
import React from 'react';
import styled from 'styled-components';
import { Colors, OutputText } from '@tls/treact-ui';
import { FlagChecked, FlagError } from '@tls/treact-ui/flags';

const options: Intl.DateTimeFormatOptions = {
  dateStyle: 'short',
  timeStyle: 'short',
};

export default function KpiTile({ data, materialNumber }: Readonly<{ data: KpiData; materialNumber: string }>) {
  const { i18n, t } = useTranslation();
  return (
    <Container data-testid={`settings-contracts-kpi-${materialNumber}`}>
      <Title>
        {data.isSuccess ? <FlagChecked width={'1.5rem'} /> : <FlagError width={'1.5rem'} />}
        <span className='font-size_l'>{materialNumber}</span>
      </Title>
      <Details>
        <OutputText
          label={t('settings.contracts.kpi.lastFetch')}
          infoPrimary={new Date(data.lastFetch).toLocaleString(i18n.language, options)}
          asAtom
          data-testid={`settings-contracts-kpi-${materialNumber}-last-fetch`}
        />
        {data.nextFetch && (
          <OutputText
            label={t('settings.contracts.kpi.nextFetch')}
            infoPrimary={new Date(data.nextFetch).toLocaleString(i18n.language, options)}
            asAtom
            data-testid={`settings-contracts-kpi-${materialNumber}-next-fetch`}
          />
        )}
      </Details>
      {data.lastError && (
        <OutputText
          label={t('settings.contracts.kpi.lastError')}
          infoPrimary={data.lastError}
          asAtom
          data-testid={`settings-contracts-kpi-${materialNumber}-last-error`}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  border: 1px solid ${Colors.trgrey5.hex};
  padding: 0.625rem;
`;

const Details = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.625rem;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.625rem;
`;
